import apiClient from '@/axios';
import { message } from 'ant-design-vue';

const state = {
  casesList: {},
  caseView: {},
  caseDropdowns: {},
};

const getters = {
  getOrgSupportCasesList: (state) => state.casesList,
  getOrgSupportCaseView: (state) => state.caseView,
  getOrgSupportCaseDropdowns: (state) => state.caseDropdowns,
};

const mutations = {
  SET_ORG_SUPPORT_CASES_LIST(state, data) {
    state.casesList = data;
  },
  SET_ORG_SUPPORT_CASE_VIEW(state, data) {
    state.caseView = data;
  },
  SET_ORG_SUPPORT_CASE_DROPDOWNS(state, data) {
    state.caseDropdowns = data;
  },
};

const actions = {
  async fetchOrgSupportCaseOptions({ commit }) {
    try {
      const response = await apiClient.get('/settings/support-cases');
      if (response.data?.status) {
        commit('SET_ORG_SUPPORT_CASE_DROPDOWNS', response.data.data.dropdowns || {});
        return response.data.data;
      }
    } catch (error) {
      console.error('Error fetching support case options:', error);
    }
  },
  async fetchOrgSupportCases({ commit }, params) {
    try {
      const response = await apiClient.get('/support-case/list', { params });
      commit('SET_ORG_SUPPORT_CASES_LIST', response.data.data);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching support cases:', error);
    }
  },
  async fetchOrgSupportCase({ commit }, id) {
    try {
      const response = await apiClient.get(`/support-case/view/${id}`);
      commit('SET_ORG_SUPPORT_CASE_VIEW', response.data.data);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching support case:', error);
    }
  },
  async createOrgSupportCase(_ctx, form) {
    try {
      const response = await apiClient.post('/support-case/create', form);
      if (response.data?.status) {
        message.success(response.data.message || 'Support case created');
      }
      return response.data;
    } catch (error) {
      console.error('Error creating support case:', error);
      message.error(error?.response?.data?.message || 'Unable to create support case');
      return error?.response?.data;
    }
  },
  async updateOrgSupportCase(_ctx, form) {
    try {
      const response = await apiClient.post(`/support-case/update/${form.id}`, form);
      if (response.data?.status) {
        message.success(response.data.message || 'Support case updated');
      }
      return response.data;
    } catch (error) {
      console.error('Error updating support case:', error);
      message.error(error?.response?.data?.message || 'Unable to update support case');
      return error?.response?.data;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
